module.exports = __webpack_public_path__ + "img/sfrags.70a7ae66.png";